<template>
  <div class="gestionar-producto-final container-fluid mt-4">

    <!-- Título -->
    <h2 class="mb-4 text-bulk">
      <font-awesome-icon icon="box" class="me-2" />
      Producto Final Bulk
    </h2>



    <!-- Botonera -->
    <div class="d-flex flex-wrap gap-3 mb-4">
      <button class="btn btn-bulk" @click="showList">
        <font-awesome-icon icon="list" class="me-2" /> Listar Productos Bulk
      </button>
      <button class="btn" :class="mostrarSinStock ? 'btn-outline-danger' : 'btn-outline-success'"
        @click="toggleStockView">
        <font-awesome-icon :icon="mostrarSinStock ? 'eye' : 'eye-slash'" class="me-2" />
        {{ mostrarSinStock ? 'Mostrar Con Stock' : 'Mostrar Sin Stock' }}
      </button>

    
    </div>

    <!-- Vista dinámica -->
    <component :is="actualViewComponent" :producto_final_bulk_id="selectedBulkId" :producto="selectedBulk"
      :sinStock="mostrarSinStock" @viewChange="handleViewChange" @cancelar="showList"
      @productoFinalBulkCreado="showList" @productoBulkEditado="showList" @envasadoFinalizado="showList"
      @ajusteRealizado="showList" />


    <!-- Botón volver -->
    <div class="d-flex justify-content-end mt-4" v-if="actualView !== 'listar'">
      <button class="btn btn-secondary" @click="showList">
        <font-awesome-icon icon="arrow-left" class="me-1" /> Volver a Listar
      </button>
    </div>

  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import axios from '@/axios';
import { mapGetters } from 'vuex';

import ListarProductoFinalBulk from '@/components/ProductoFinal/ListarProductoFinalBulk.vue';
import FormProductoFinalBulkCrear from '@/components/ProductoFinal/FormProductoFinalBulkCrear.vue';
import ProcesarEnvasadoProductoFinal from '@/components/ProductoFinalEnvasado/ProcesarEnvasadoProductoFinal.vue';
import ListaPendientesEnvasado from '@/components/ProductoFinal/ListaPendientesEnvasado.vue';
import FormProductoFinalBulkEditar from '@/components/ProductoFinal/FormProductoFinalBulkEditar.vue';
import AjustarCantidadProductoFinalBulk from '@/components/ProductoFinal/AjustarCantidadProductoFinalBulk.vue';

export default {
  name: 'GestionarProductoFinal',
  components: {
    FontAwesomeIcon,
    ListarProductoFinalBulk,
    FormProductoFinalBulkCrear,
    ProcesarEnvasadoProductoFinal,
    ListaPendientesEnvasado,
    FormProductoFinalBulkEditar,
    AjustarCantidadProductoFinalBulk
  },
  props: {
    sinStock: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      actualView: 'listar',
      selectedBulkId: null,
      selectedBulk: null,
      pendingEnvasadoCount: 0,
      mostrarSinStock: false
    };
  },
  computed: {
    ...mapGetters(['getClubActual']),
    actualViewComponent() {
      switch (this.actualView) {
        case 'crear': return 'FormProductoFinalBulkCrear';
        case 'editar': return 'FormProductoFinalBulkEditar';
        case 'ajustarCantidad': return 'AjustarCantidadProductoFinalBulk';
        case 'pendientes': return 'ListaPendientesEnvasado';
        case 'procesar': return 'ProcesarEnvasadoProductoFinal';
        default: return 'ListarProductoFinalBulk';
      }
    }
  },
  methods: {
    showList() {
      this.actualView = 'listar';
      this.selectedBulkId = null;
    },
    showCreate() {
      this.actualView = 'crear';
      this.selectedBulkId = null;
    },
    showPendientesEnvasado() {
      this.actualView = 'pendientes';
      this.selectedBulkId = null;
    },
    handleViewChange({ view, productoFinalBulk }) {
      this.actualView = view;
      this.selectedBulk = productoFinalBulk;
      this.selectedBulkId = productoFinalBulk.id || null;
    },
    async fetchPendingEnvasadoCount() {
      try {
        const url = this.sinStock
          ? '/api/producto_final_bulk_sin_stock'
          : '/api/producto_final_bulk_con_stock'; // suponiendo que renombrás el endpoint original

        const res = await axios.get(url, {
          params: { club_id: this.getClubActual.id }
        });
        this.pendingEnvasadoCount = (res.data || []).length;
      } catch (e) {
        console.error('Error al obtener pendientes de envasado:', e);
      }
    },
    toggleStockView() {
      this.mostrarSinStock = !this.mostrarSinStock;
      this.showList(); // actualiza la vista para refrescar la lista
    }

  },
  mounted() {
    this.fetchPendingEnvasadoCount();
  }
};
</script>

<style scoped>
.gestionar-producto-final {
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.05);
}

.text-bulk {
  color: #205375;
  /* Azul petróleo / industrial */
}

.btn-bulk {
  background-color: #205375;
  color: white;
}

.btn-bulk:hover {
  background-color: #163a53;
}

.btn-outline-bulk {
  border-color: #205375;
  color: #205375;
}

.btn-outline-bulk:hover {
  background-color: #205375;
  color: white;
}

.alert-pendiente {
  background-color: #f2f6fa;
  border-color: #cfdbe6;
}

.border-bulk-warning {
  border-color: #ffd966 !important;
}

.text-bulk-warning {
  color: #d97706;
}

.btn-bulk-warning {
  background-color: #ffd966;
  color: #5d4d00;
}

.btn-bulk-warning:hover {
  background-color: #ffcd39;
  color: #3d3200;
}
</style>
